import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

import { Footer } from './components/layout/Footer'
import type { FooterLinkKey } from './components/layout/Footer'
import { Header } from './components/layout/Header'
import type {
  HeaderActionKey,
  HeaderNavItemKey,
} from './components/layout/Header'
import { ComingSoonPage } from './features/coming-soon/ComingSoonPage'

const disabledHeaderNavItems: HeaderNavItemKey[] = ['team', 'news', 'about', 'library']
const disabledHeaderActions: HeaderActionKey[] = ['signIn','search']
const disabledFooterLinks: FooterLinkKey[] = ['archive']

function App() {
  const { t, i18n } = useTranslation()
  const pageTitle = t('comingSoon.meta.title')
  const pageDescription = t('comingSoon.meta.description')
  const pageUrl = 'https://inspipulse.com/'
  const previewImage = 'https://inspipulse.com/logo.png'
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'InspiPulse Library',
    url: pageUrl,
    description: pageDescription,
    inLanguage: i18n.language,
  }

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={pageUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="InspiPulse Library" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={previewImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={previewImage} />

        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      </Helmet>

      <div
        id="top"
        className="min-h-screen bg-[var(--color-background)] text-[var(--color-on-background)]"
      >
        <Header
          disabledNavItems={disabledHeaderNavItems}
          disabledActions={disabledHeaderActions}
        />
        <ComingSoonPage />
        <Footer disabledLinks={disabledFooterLinks} />
      </div>
    </>
  )
}

export default App
